export const SEARCH_ALL_REPORTS = 'SEARCH_ALL_REPORTS';
export const SEARCH_PREMADE_REPORTS = 'SEARCH_PREMADE_REPORTS';
export const EMPTY = 'EMPTY';
